import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { getOptionsQueryParams } from "@app/class/Utilities";
import { Observable } from "rxjs";
import { IVisitFailureRecord } from "../_models/IVisitFailureRecord";
import { IVisitFailureRecordQueryOptions } from "../_models/IVisitFailureRecordQueryOptions";

@Injectable({
    providedIn: 'root'
})
export class VisitFailureService {

    constructor(
        private readonly http: HttpClient
    ) { }

    getVisitFailures(options?: IVisitFailureRecordQueryOptions): Observable<IVisitFailureRecord[]> {
        const params = getOptionsQueryParams(options);
        return this.http.get<IVisitFailureRecord[]>(`/api/foundation/visitfailure`, params)
    }

    saveVisitFailure(visitFailure: IVisitFailureRecord): Observable<IVisitFailureRecord> {
        return this.http.post<IVisitFailureRecord>(`/api/foundation/visitfailure`, visitFailure);
    }
}
